import axios from 'axios';
import store from '../index';
//import Message from '@/modules/message'
const state = {
	order: '',
	io: {},
	MESSAGE_ORDER: '',
	MESSAGE_CRON: '',
	MESSAGE_UPDATE_ORDER: '',
};

const getters = {
	getOrder: state => {
		return state.order;
	},
};

const actions = {
	disconnect: context => {
		const io = context.state.io;
		if (io && typeof io.disconnect === 'function') io.disconnect();
	},
	// Entra nella stanza del profilo: il backend la ricava dal token e fa uscire il socket
	// da quella dell'account precedente. Va chiamata a ogni cambio di sessione (login,
	// "Accedi come", rinnovo del token) e a ogni (ri)connessione del socket.
	socket_login: async context => {
		const io = context.rootState.socket.io;
		// localStorage e' la fonte aggiornata in ogni cambio di sessione (anche "Ritorna ad ...")
		const token = localStorage.getItem('token') || context.rootGetters['profile/getToken'];
		if (!io || typeof io.emit !== 'function' || !token) return;
		// dopo il logout il socket e' chiuso: al login successivo va riaperto (il join parte alla connessione)
		if (io.connected === false && typeof io.connect === 'function') {
			io.connect();
			return;
		}
		io.emit('join', { token }, () => {});
	},
	// connessione e riconnessioni: le stanze sul server si perdono, si rientra
	SOCKET_connect: async context => {
		context.dispatch('socket_login');
	},
	SOCKET_MESSAGE_UPDATE_ORDER: async (context, data) => {
		context.dispatch('orders/updateFromSocket', {}, { root: true });

		//console.log("context",context)
	},
	SOCKET_PACKING_LIST_STARTED: async (context, data) => {
		context.dispatch('dispatchOrders/updateFromSocket', {}, { root: true });
	},
	SOCKET_PACKING_LIST_CANCELLED: async (context, data) => {
		context.dispatch('dispatchOrders/updateFromSocket', {}, { root: true });
	},
	CATEGORY_NOTIFY: async (context, data) => {
		console.log('CATEGORY', data);

		context.dispatch('settings/updateData', JSON.parse(data), { root: true });

		//console.log("context",context)
	},
	SOCKET_MESSAGE_NEW_ORDER: async (context, data) => {
		//console.log("NUOVO ORDINE",data)
		//context.dispatch('notify/asyncPreviewData', {}, {root:true})
		context.dispatch('orders/newFromSocket', {}, { root: true });
		context.dispatch('settings/updateSnackbar', { color: 'info', text: 'Nuovo ordine', snackbar: true, mode: 'multi-line', timeout: 5000 }, { root: true });
		//console.log("context",context)
	},
	// Utenti > Task: una issue o uno sprint del profilo e' cambiato, board/backlog aperti si ricaricano
	SOCKET_TASK_UPDATED: (context, data) => {
		context.dispatch('tasks/remoteChange', data, { root: true });
	},
	// nuova notifica salvata dal backend (Notify.storeNotify): aggiorna solo il campanello
	SOCKET_NOTIFY_REFRESH: context => {
		context.dispatch('notify/refreshPreviews', {}, { root: true });
	},
	SOCKET_MESSAGE_NOTIFY: async (context, data) => {
		console.log('NOTIFICA', data);
		/* this.setSnackbar({color:"success",
                              text:"text",
                            snackbar:true,

                            mode:"multi-line",
                            timeout:5000})*/
		context.dispatch('notify/asyncPreviewData', {}, { root: true });
		context.dispatch('settings/updateSnackbar', { color: 'info', text: data, snackbar: true, mode: 'multi-line', timeout: 5000 }, { root: true });

		//console.log("context",context)
	},
};

const mutations = {
	//MESSAGE_UPDATE_ORDER
	SOCKET_MESSAGE_ORDER: (state, message) => {
		//console.log("state order",state)
		//console.log("message order",message)
		state.MESSAGE_ORDER = message;
	},
	/*SOCKET_MESSAGE_CRON: (state,message) => {

        console.log("state cron",state)
        console.log("message cron",message)
        state.MESSAGE_ORDER= message;

    },*/

	/* SOCKET_MESSAGE_UPDATE_ORDER: (state,message) => {


        //update_item()
        //this.dispatch('socket/update_item',{});
        //this.$store.dispatch('update_item')

        state.MESSAGE_UPDATE_ORDER= message;

    },*/

	MESSAGE_ORDER: (state, message) => {
		// console.log(state)
		// console.log(message)
		state.MESSAGE_ORDER = message;
	},
	setSocket: (state, socket) => {
		state.io = socket;
		//console.log("socket connect 2")
	},
};

const modules = {
	//  Message
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
	modules,
};
